import $ from 'jquery';
import {createFormSpinner} from "./helpers/spinner";

$(document).ready(function () {
    $(document).on('click', '[data-btn="change-training-catalogue"]', function (e) {
        e.preventDefault();

        // Учитываем клик именно по стрелкам
        const btn = e.target.closest('.arrow-prev, .arrow-next');
        if (!btn) return;

        e.preventDefault();

        const trainingId = btn.dataset.targetId;
        const trainingIds = btn.dataset.trainingIds;
        const urlBase = btn.dataset.urlBase;

        // Получаем данные текущей формы
        const $form = $('#training-schedule');
        const formData = $form.serializeArray();

        // Собираем GET-параметры из данных формы
        const params = new URLSearchParams();

        formData.forEach(({name, value}) => {
            if(name === 'training_catalogue_schedule_form[training]') {
                // return;
            }
            params.append(name, value);
        });

        // Добавляем параметры, чтобы контроллер знал весь контекст
        params.append('trainingIdsJson', trainingIds);

        const url = `${urlBase}/${trainingId}?${params.toString()}`;

        // Показываем спиннер в теле модалки
        document.querySelector('.modal-body').innerHTML = createFormSpinner();
        document.querySelector('.modal-header').innerHTML = 'Loading...';

        fetch(url)
            .then(res => res.text())
            .then(html => {
                document.querySelector('.modal-content').innerHTML = html;
                $('#modal-common').trigger('update.bs.modal');
            })
            .catch(err => console.error('Ошибка при загрузке модалки:', err));
    });
});
